/**
 * Umami + auto-tracking only when running the production app config
 * (see env.samples/production.env: REACT_APP_ENV=production).
 */
export function isAnalyticsEnabled() {
  return (
    typeof process !== "undefined" &&
    process.env &&
    process.env.REACT_APP_ENV === "production"
  );
}
